export class RegexStore {
    public static readonly GlobalBlankSpace = /\s/g;
    public static readonly GlobalNewLine = /\n|\r|\r\n/g;
    public static readonly GlobalNonBreakingSpace = /\u00A0/g;
    public static readonly GlobalDigits = /\d+/g;
    public static readonly AllNumbersAtTheEnd = /[0-9]+$/;
    public static readonly GlobalSpace = / /g;
}
